import { EmployeesRole } from '../types/employees';
import { convertDateToOnschedHours } from '../utils/global/helper';

export const DEFAULT_START_TIME = convertDateToOnschedHours(
  new Date(0, 0, 0, 11, 0),
);

export const DEFAULT_END_TIME = convertDateToOnschedHours(
  new Date(0, 0, 0, 18, 0),
);

export const DAYS_ORDER = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const MANAGER_ROLES: EmployeesRole[] = [
  EmployeesRole.SHOP_MANAGER,
  EmployeesRole.SHOP_BOOKER,
];

export const EMPLOYEE_COLOR_OPTIONS = [
  '#039BE5', // Peacock
  '#33B679', // Sage
  '#D50000', // Tomato
  '#8E24AA', // Grape
  '#F6BF26', // Banana
  '#F4511E', // Tangerine
  '#B39DDB', // Wisteria
  '#C0CA33', // Avocado
  '#0B8043', // Basil
  '#3F51B5', // Blueberry
  '#7986CB', // Lavender
  '#7CB342', // Pistachio
  '#E67C73', // Flamingo
  '#616161', // Graphite
  '#795548', // Cocoa
  '#F09300', // Mango
  '#D81B60', // Cherry Blossom
  '#A79B8E', // Birch
  '#9E69AF', // Amethyst
  '#4285F4', // Cobalt
  '#009688', // Eucalyptus
  '#E4C441', // Citron
  '#EF6C00', // Pumpkin
  '#AD1457', // Radicchio
];
